import {ElMessage, ElMessageBox} from "element-plus";

let Common = {
//二次确认
  confirm: (title = '提示', content = '确定要删除吗？', confirmButtonText = '确定', cancelButtonText = '返回', type = 'warning') => {
    return new Promise((resolve, reject) => {
      ElMessageBox.confirm(
          content,
          title,
          {
            confirmButtonText,
            cancelButtonText,
            type,
          }
      )
          .then(() => {
            //ElMessage({
            //  type: 'success',
            //  message: '操作成功',
            //})
            resolve('success')
          })
          .catch(() => {
            ElMessage({
              type: 'info',
              message: '取消操作',
            })
            reject('cancel')
          })
    })
  }
}

export default Common;




